// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"08ca43e0","434":"3ccdc623"}[chunkId] + ".chunk.js";
};